import { translate } from '@ngneat/transloco';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { specialCharsParser2026 } from './utils';
import moment from 'moment';
import { AbstractControl } from '@angular/forms';

export const sharedHealthInsurer2026 = (guide = false): FormlyFieldConfig[] => [
  {
    key: 'zdravPojistovna',
    type: 'select',
    className: 'p-col-12 p-sm-8',
    props: {
      placeholder: 'TPA.SelectPlaceholder',
      translate: true,
      label: 'TPA.HealthInsurance',
      translateOptions: true,
      required: true,
      options: [
        { label: 'Všeobecná zdravotní pojišťovna - 111', value: 111 },
        { label: 'Vojenská zdravotní pojišťovna - 201', value: 201 },
        { label: 'Česká průmyslová zdravotní pojišťovna - 205', value: 205 },
        {
          label: 'Oborová ZP zaměstnanců bank a pojišťoven - 207',
          value: 207,
        },
        { label: 'Zaměstnanecká pojišťovna Škoda - 209', value: 209 },
        {
          label: 'Zdravotní pojišť. Ministerstva vnitra ČR - 211',
          value: 211,
        },
        { label: 'Revírní bratrská pokladna - 213', value: 213 },
        { label: 'Zdravotní pojišťovna METAL-ALIANCE - 217', value: 217 },
        { label: 'Zdravotní pojišťovna MÉDIA - 228', value: 228 },
        { label: 'TPA.Other', value: 0 },
      ],
      change: (field, event) => {
        if (
          event.itemData &&
          event.itemData.value &&
          event.itemData.value != 0
        ) {
          // TPACHANGES: this part was rewrited
          // this issue
          // const rc =
          //   this.formControl.root.value.personalPart?.personalInfo.rodneCislo;
          // const cisloPojistence = field?.parent?.fieldGroup?.find(
          //   (p) => p.key == 'cisloPojistence'
          // );
          // if (rc && cisloPojistence?.formControl)
          //   cisloPojistence.formControl.patchValue(
          //     (rc as string).replace('/', '')
          //   );
        }
      },
    },
    expressionProperties: {
      'props.change': 'formState.changeZdravPojistovna',
    },
  },
  {
    key: 'jinaZdravPojistovna', //V případě "Jiná" pojišťovna string input pro další specifikaci pojišťovny.
    type: 'input',
    className: 'p-col-12 p-sm-4',
    parsers: [specialCharsParser2026],
    modelOptions: {
      updateOn: 'blur',
    },
    props: {
      label: 'TPA.OtherHealthInsurance',
      translate: true,
      required: true,
    },
    hideExpression: '(model?.zdravPojistovna != 0)',
  },
  {
    key: 'cisloPojistence', //V případě ČR je to RČ
    type: 'input',
    className: 'p-col',
    parsers: [specialCharsParser2026],
    modelOptions: {
      updateOn: 'blur',
    },
    props: {
      label: 'TPA.InsuranceNumber',
      translate: true,
      required: true,
      tooltip: 'TPA.InsuranceNumberTooltip',
    },
  },
  {
    key: 'a1',
    type: 'checkbox',
    className: 'p-col-12',
    props: {
      checkboxLabel: 'TPA.A1',
      translate: true,
      ...(!guide ? { tooltip: 'TPA.A1Tooltip' } : {}),
    },
  },
  ...(guide
    ? [
      {
        template: `<p class="description">${translate(
          'TPA.Guide.Step6A1Description'
        )} </p>`,
      },
    ]
    : []),
];

export const sharedHealthCondition2026 = (): FormlyFieldConfig[] => [
  {
    key: 'zdravotniZnevyhodneni',
    type: 'select',
    className: 'p-col-12 p-md-8',
    props: {
      placeholder: 'TPA.SelectPlaceholder',
      translate: true,
      label: 'TPA.HealthDisadvantage',
      required: true,
      translateOptions: true,
      defaultValue: null,
      options: [
        { label: 'TPA.No', value: 'no' },

        { label: 'TPA.Ozz', value: 'ozz' },

        {
          label: 'TPA.InvalidityOne',
          value: 'firstdegreeinvalidity',
        },
        {
          label: 'TPA.InvalidityTwo',
          value: 'seconddegreeinvalidity',
        },
        {
          label: 'TPA.InvalidityThree',
          value: 'thirddegreeinvalidity',
        },
      ],
    },
  },
  {
    key: 'ztpp',
    type: 'select',
    className: 'p-col',
    props: {
      placeholder: 'TPA.SelectPlaceholder',
      label: 'TPA.Ztpp',
      translate: true,
      translateOptions: true,
      required: true,
      options: [
        { label: 'TPA.No', value: false },
        { label: 'TPA.Yes', value: true },
      ],
    },
  },
  {
    key: 'priznaneOd',
    type: 'date-picker',
    className: 'p-col-12 p-md-6',
    props: {
      label: 'TPA.HealthDisadvantageFrom',
      required: true,
      translate: true,
    },
    expressionProperties: {
      'props.required': (m, formState, field) => {
        return (
          m?.zdravotniZnevyhodneni == 'firstdegreeinvalidity' ||
          m?.zdravotniZnevyhodneni == 'seconddegreeinvalidity' ||
          m?.zdravotniZnevyhodneni == 'thirddegreeinvalidity' ||
          m?.zdravotniZnevyhodneni == 'ozz'
        );

      },
      "hide": (m, formState, field) => {
        return (
          m?.zdravotniZnevyhodneni == 'no' || !m?.zdravotniZnevyhodneni
        );
      }
    }
  },
  {
    key: 'priznaneDo',
    type: 'date-picker',
    className: 'p-col-12 p-md-6',
    props: {
      label: 'TPA.HealthDisadvantageTo',
      translate: true,
    },
    expressionProperties: {
      "hide": (m, formState, field) => {
        return (
          m?.zdravotniZnevyhodneni == 'no' || !m?.zdravotniZnevyhodneni
        );
      }
    }
  },
];
/**
 *
 * @param question question to be displayed
 * @param duplicateQuestion question to be displayed when answer is true
 * @returns
 */
export const sharedRetirement2026 = (
  question: FormlyFieldConfig = {
    key: 'pobiramDuchod',
    type: 'yes-or-no',
    className: 'p-col-12',
    props: {
      required: true,
      label: 'TPA.GotPension',
      yesText: 'TPA.Yes',
      noText: 'TPA.No',
      translate: true,
    },
  },
  duplicateQuestion: FormlyFieldConfig = {
    key: 'pobiramDuchod',
    type: 'checkbox',
    className: 'p-col-12',
    props: {
      checkboxLabel: 'TPA.GotPension',
      translate: true,
    },
    hideExpression: '(model?.pobiramDuchod == true)',
  },
  additionalQuestion: FormlyFieldConfig | undefined = undefined,
): FormlyFieldConfig => ({
  className: 'p-col-12',
  key: 'duchody',
  fieldGroup: [
    question,
    {
      className: 'p-col-12',
      hideExpression: '(model?.pobiramDuchod != true)', fieldGroup: [
        duplicateQuestion,
        {
          key: 'starobni',
          wrappers: ['panel-wrapper'],
          className: 'p-col-12',


          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.RetirementPension',

                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }

            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {
                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'predcasnyStarobniDuchod',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.EarlyRetirementPension',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {
                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'starobniDuchodSeSnizenymDuchodovymVekem',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithReducedPensionAge',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {
                  return !(m?.pobiran)
                },
              }
            },
          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        }, {


          wrappers: ['panel-wrapper'],
          key: 'invalidni',
          className: 'p-col-12',
          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithInvalidityOneTwo',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },

          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        }, {


          wrappers: ['panel-wrapper'],

          key: 'invalidniTretihoStupne',
          className: 'p-col-12',
          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithInvalidityThree',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },

          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        },
        additionalQuestion,
        {


          wrappers: ['panel-wrapper'],
          key: 'starobniZahranicni',
          className: 'p-col-12',
          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithStarobnialPensionAbroad',

                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }

            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {
                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'predcasnyStarobniDuchod',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.EarlyRetirementPension',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {
                  return !(m?.pobiran)
                },
              }
            },
          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        },
        {
          wrappers: ['panel-wrapper'],


          key: 'invalidniZahranicni',
          className: 'p-col-12',
          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithInvalidityOneTwoAbroad',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },
          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        },
        {
          wrappers: ['panel-wrapper'],

          key: 'invalidniZahranicniTretihoStupne',
          className: 'p-col-12',
          fieldGroup: [
            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.PensionWithInvalidityThreeAbroad',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'pobiranOd',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenFrom',
                required: true,
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },
            {
              key: 'pobiranDo',
              type: 'date-picker',
              className: 'p-col-12',
              props: {
                label: 'TPA.TakenTo',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },

          ],
          validators: {
            validation: [
              {
                name: 'dateRangeTakesValidationError',
                options: { errorPath: 'pobiranDo' },
              },
            ],
          },

        },

        {


          wrappers: ['panel-wrapper'],

          key: 'jiny',
          className: 'p-col-12',
          fieldGroup: [

            {
              key: 'pobiran',
              type: 'yes-or-no',
              className: 'p-col-12',
              props: {
                required: true,
                label: 'TPA.OtherPension',
                yesText: 'TPA.Yes',
                noText: 'TPA.No',
                translate: true,
              },
            },
            {
              key: 'nazevDuchodu',
              type: 'input',
              className: 'p-col-12',
              parsers: [specialCharsParser2026],
              modelOptions: {
                updateOn: 'blur',
              },
              props: {
                label: 'TPA.OtherPensionDescription',
                translate: true,
              },
              expressionProperties: {
                'hide': (m, formState, field) => {

                  return !(m?.pobiran)
                },
              }
            },

          ],

        },
      ],
    },
  ],
});
